<template>
  <div :class="isPC ? 'page-wrapper' : 'm-page-wrapper'">
    <div :class="[isPC ? 'header-part' : 'm-header-part', { 'star-header-part': isStar }]">
      <!-- <div class="top-icon">
        <span></span>
      </div> -->
      <!-- <h1>2020(第八届)</h1>
      <h1 v-if="isPC">上海国际青少年科技博览会(云端展会)</h1>
      <h1 v-if="!isPC">上海国际青少年科技博览会</h1>
      <h1 v-if="!isPC">(云端展会)</h1>
      <h4 v-if="isPC">8th Shanghai International Youth Science and Technology Expo 2020</h4>
      <h4 v-if="!isPC">8th Shanghai International</h4>
      <h4 v-if="!isPC">Youth Science and Technology Expo 2020</h4>
      <h4>(Online Exhibition)</h4> -->
      <div v-if="isPC" :class="['button-group', { 'is625': is625 }]">
        <!-- <div class="tab-item">
          <p class="tab-left">平面展 2D Exhibition</p>
          <span class="button-left" @click="goToWeb('cn')">中文</span>
          <span class="button-left" @click="goToWeb('en')">English</span>
        </div> -->
        <div class="tab-item">
          <p class="tab-right">虚拟展 Virtual Exhibition</p>
          <span class="button-right" @click="goToVR('cn')">中文</span>
          <span class="button-right" @click="goToVR('en')">English</span>
        </div>
      </div>
      <div v-else class="m-button-group">
        <!-- <div class="m-tab-item">
          <p class="m-tab-left">平面展 2D Exhibition</p>
          <span class="button-left" @click="goToWeb('cn', 'showMenu')">中文</span>
          <span class="button-left" @click="goToWeb('en', 'showMenu')">English</span>
        </div> -->
        <div class="m-tab-item">
          <p class="m-tab-right">虚拟展 Virtual Exhibition</p>
          <span class="button-right" @click="goToVR('cn')">中文</span>
          <span class="button-right" @click="goToVR('en')">English</span>
        </div>
      </div>
      <div class="info-area">
        <p class="cn-font">中国<span class="dot-item"></span>上海</p>
        <p>SHANGHAI<span class="dot-item"></span>CHINA</p>
        <p class="cn-font">2024年8月2日 - 6日</p>
        <p>August 2-6, 2024</p>
      </div>
      <div v-if="isPC" class="footer-area">
        <WebFooter />
      </div>
    </div>
    <WebFooter v-if="!isPC" />
  </div>
</template>

<script>
import WebFooter from '@/common/WebFooter'
export default {
  name: 'MainPage',
  components: { WebFooter },
  data() {
    return {
      is625: window.innerWidth > 625,
      isStar: false
    }
  },
  watch: {
    '$route': function (routerTo) {
      if (routerTo.path.indexOf('/web/starlight') > -1) {
        this.isStar = true;
      } else {
        this.isStar = false;
      }
    }
  },
  created() {
    if (this.$route.path.indexOf('/web/starlight') > -1) {
      this.isStar = true;
    } else {
      this.isStar = false;
    }
  },
  methods: {
    goToWeb(lang, showMenu) {
      if (lang !== this.currentLang) {
        this.changeLang(lang)
      }
      if (showMenu) {
        this.$router.push({ name: 'menter' })
      } else {
        this.$router.push({ name: 'web' })
      }
    },
    goToVR(lang) {
      if (lang !== this.currentLang) {
        this.changeLang(lang)
      }
      this.$router.push({ name: 'kr_view' })
    }
  }
}
</script>

<style scoped>
.page-wrapper {
  width: 100%;
  height: 100%;
  position: relative;
}

.header-part {
  width: 100%;
  background-image: url("../assets/web/main_bg.png");
  min-height: 80rem;
  height: 100%;
  background-size: 100% 100%;
  background-position: center;
  background-repeat: no-repeat;
  position: relative;
}

.header-part.star-header-part {
  background-image: url("../assets/web/top_header_bg1.jpg");
  background-size: 100% 100%;
  background-position: center;
  background-repeat: no-repeat;
}

.top-icon {
  text-align: center;
  padding-top: 5.5rem;
  padding-bottom: 1rem;
}

.top-icon span {
  display: inline-block;
  width: 13rem;
  height: 16rem;
  background-image: url("../assets/web/main_icon.png");
  background-size: 100% 100%;
}

.header-part h1,
.m-header-part h1 {
  font-size: 4rem;
  color: #0088d3;
  text-align: center;
  font-weight: bolder;
}

.header-part h4,
.m-header-part h4 {
  font-size: 2.4rem;
  color: #0088d3;
  text-align: center;
}

.button-group {
  padding-top: 40rem;
  text-align: center;
}

.button-group.is625 {
  padding-top: 50vh;
}

.tab-item {
  display: inline-block;
  font-size: 1.8rem;
  font-weight: 550;
}

.tab-item p {
  padding: 10px 20px 6px;
  min-width: 180px;
  font-size: 2.4rem;
}

.tab-item span {
  margin-left: 5px;
  margin-right: 5px;
  font-size: 2rem;
  height: 4rem;
  /* width: 8rem; */
  line-height: 4rem;
  padding-left: 1.4rem;
  padding-right: 1.4rem;
  border-radius: 2rem;
  display: inline-block;
  cursor: pointer;
}

.tab-left {
  color: #ffffff;
  border-bottom: 2px solid #ffffff;
}

.tab-right {
  color: #eae82d;
  border-bottom: 2px solid #eae82d;
}

.button-left {
  border: 1px solid #ffffff;
  color: #ffffff;
}

.button-left:hover {
  background-color: #ffffff;
  color: #0088d3;
}

.button-right {
  border: 1px solid #ffffff;
  color: #ffffff;
}

.button-right:hover {
  background-color: #ffffff;
  color: #0088d3;
}

.info-area {
  text-align: center;
  color: #ffffff;
  margin-top: 4rem;
  font-size: 20px;
  font-weight: 550;
}

.info-area p {
  margin-top: 0px;
  margin-bottom: 10px;
  line-height: 1;
}

.cn-font {
  letter-spacing: 2px;
}

.dot-item {
  display: inline-block;
  width: 8px;
  height: 8px;
  vertical-align: middle;
  border-radius: 50%;
  background-color: #ffffff;
  margin-left: 10px;
  margin-right: 10px;
}

.footer-area {
  position: absolute;
  bottom: 0px;
  width: 100%;
  text-align: center;
}

/* 移动端 */
.m-page-wrapper {
  width: 100%;
  height: 100%;
  position: relative;
}

.m-header-part {
  width: 100%;
  background-image: url("../assets/m/main_bg.jpg");
  min-height: 600px;
  height: 100%;
  background-size: 100% 100%;
  background-repeat: no-repeat;
}

.m-button-group {
  text-align: center;
  width: 80%;
  margin: 0 auto;
  padding-top: 325px;
}

.m-header-part .m-button-group {
  padding-top: 56vh;
}

.m-tab-item {
  width: 100%;
  display: inline-block;
}

.m-tab-item span {
  font-size: 15px;
  height: 30px;
  width: 90px;
  line-height: 30px;
  border-radius: 15px;
  margin-left: 5px;
  margin-right: 5px;
  display: inline-block;
  cursor: pointer;
}

.m-tab-item p {
  padding: 10px 20px 6px;
  margin-bottom: 15px;
}

.m-tab-left {
  color: #ffffff;
  border-bottom: 2px solid #ffffff;
}

.m-tab-item .button-left {
  width: 40%;
  color: #ffffff;
}

.m-tab-item .button-left:hover {
  background-color: inherit;
  color: #ffffff;
}

.m-tab-item .button-right:hover {
  background-color: inherit;
  color: #ffffff;
}

.m-tab-right {
  color: #eae82d;
  border-bottom: 2px solid #eae82d;
}

.m-tab-item .button-right {
  width: 40%;
  color: #ffffff;
}

.m-header-part .info-area {
  margin-top: 20px;
  font-size: 16px;
}

.m-header-part .info-area p {
  margin-bottom: 6px;
}

@media screen and (max-width: 900px) {}
</style>
